// src/pages/Fab/BracketCreation/BracketControlsButtons.jsx
import React from "react";
import api from "@api";
import { generateBracket } from "../BracketCreation/Utils/bracketUtils.js";
import "./BracketControlsButtons.css";

function BracketControlsButtons({
  division,
  bracketData,
  setDivision,
  setBracketData,
  isBracketSaved,
  setIsBracketSaved,
  showManual,
  setShowManual,
  bracketTeamCount,
  setBracketTeamCount,
  setGames,
}) {
  if (!division) return null;

  return (
    <div className="bracket-controls-container">
      {!bracketData && (
        <>
      {/* AUTO-GENERATE */}
      {/* <button
        className="bracket-controls-btn auto-btn"
            onClick={async () => {
              const count = division.teams.length;
              const result = generateBracket(count, division.teams);
              result.mode = "auto";

              try {
                await api.put(`/api/divisions/${division.id}/bracket`, {
                  bracket_json: result,
                });

                setBracketData(result);
                setDivision((prev) => ({
                  ...prev,
                  bracket_json: result,
                }));
                setIsBracketSaved(true);
              } catch (err) {
                console.error("Failed to auto-save bracket:", err);
                alert("Bracket was generated but failed to save.");
              }
            }}
      >
        Auto-Generate ({division.teams.length} teams)
      </button> */}

      {/* MANUAL GENERATE TOGGLE */}
      {!showManual && (
        <button
          className="bracket-controls-btn manual-btn"
          onClick={() => setShowManual(true)}
        >
          + Create Bracket
        </button>
      )}

      {/* MANUAL PANEL */}
      {showManual && (
        <div className="bracket-controls-manual-panel">
              <select
                className="bracket-controls-select"
                value={bracketTeamCount}
                onChange={(e) => setBracketTeamCount(Number(e.target.value))}
              >
                {[...Array(127)].map((_, i) => {
                  const teamCount = i + 2;

                  return (
                    <option key={teamCount} value={teamCount}>
                      {teamCount} Teams
                    </option>
                  );
                })}
              </select>

          <button
            className="bracket-controls-btn create-empty-btn"
                onClick={async () => {
                  const result = generateBracket(bracketTeamCount, []);
                  result.mode = "manual";

                  try {
                    await api.put(`/api/divisions/${division.id}/bracket`, {
                      bracket_json: result,
                    });

                    setBracketData(result);
                    setDivision((prev) => ({
                      ...prev,
                      bracket_json: result,
                    }));
                    setIsBracketSaved(true);
                    setShowManual(false);
                  } catch (err) {
                    console.error("Failed to auto-save manual bracket:", err);
                    alert("Bracket was created but failed to save.");
                  }
                }}
          >
            Create Empty Bracket
          </button>

          <button
            className="bracket-controls-btn cancel-btn"
            onClick={() => setShowManual(false)}
          >
            Cancel
          </button>
        </div>
          )}
        </>
      )}

      {/* SAVE */}
      {bracketData && !isBracketSaved && (
        <button
          className="bracket-controls-btn save-btn"
          onClick={async () => {
            await api.put(`/api/divisions/${division.id}/bracket`, {
              bracket_json: bracketData,
            });
            // ⬅️ REFRESH UPDATED DIVISION
            setDivision(prev => ({
              ...prev,
              bracket_json: bracketData
            }));
            setIsBracketSaved(true);
            alert("Bracket saved!");
          }}
        >
          ✅ Save Bracket
        </button>
      )}

      {/* DELETE / CLEAR */}
      {bracketData && (
        <button
          className="bracket-controls-btn delete-btn"
          onClick={async () => {
            const confirmed = window.confirm(
              isBracketSaved
                ? "Are you sure you want to delete this bracket ? All games in this bracket will also be deleted."
                : "Clear this unsaved bracket?"
            );
            if (!confirmed) return;

            if (isBracketSaved) {
              await api.put(`/api/divisions/${division.id}/bracket`, {
                bracket_json: null,
              });
            }

            setBracketData(null);
            setGames([]);
            setIsBracketSaved(false);
          }}
        >
          {isBracketSaved ? " Delete Bracket" : "Clear Bracket"}
        </button>
      )}
    </div>
  );
}

export default BracketControlsButtons;
